import gsap from 'gsap';

const HOVER_TIMESCALE = 0.35;
const TIMESCALE_DURATION = 0.8;

function getGap(track) {
  return (
    parseFloat(
      getComputedStyle(track).columnGap || getComputedStyle(track).gap
    ) || 0
  );
}

function getDuration(container) {
  const styles = getComputedStyle(container);
  const items = parseFloat(styles.getPropertyValue('--marquee-items')) || 1;
  const speed = parseFloat(styles.getPropertyValue('--marquee-speed')) || 10;

  return items * speed;
}

function getTravel(track, marquee) {
  return marquee.offsetWidth + getGap(track);
}

function initMarquee(container) {
  const track = container.querySelector('.marquee-track');
  const marquee = track?.querySelector('.marquee');

  if (!track || !marquee) return;

  let tween = null;

  const play = () => {
    const progress = tween?.progress() ?? 0;
    const timeScale = tween?.timeScale() ?? 1;

    tween?.kill();
    gsap.set(track, { x: 0 });

    tween = gsap.fromTo(
      track,
      { x: 0 },
      {
        x: () => -getTravel(track, marquee),
        duration: getDuration(container),
        ease: 'none',
        repeat: -1,
      }
    );

    tween.progress(progress);
    tween.timeScale(timeScale);
  };

  play();

  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  const onEnter = () => {
    gsap.to(tween, {
      timeScale: HOVER_TIMESCALE,
      duration: TIMESCALE_DURATION,
      ease: 'power2.out',
      overwrite: true,
    });
  };

  const onLeave = () => {
    gsap.to(tween, {
      timeScale: 1,
      duration: TIMESCALE_DURATION,
      ease: 'power2.out',
      overwrite: true,
    });
  };

  const bindHover = () => {
    container.addEventListener('mouseenter', onEnter);
    container.addEventListener('mouseleave', onLeave);
  };

  const unbindHover = () => {
    container.removeEventListener('mouseenter', onEnter);
    container.removeEventListener('mouseleave', onLeave);
    if (tween) tween.timeScale(1);
  };

  if (canHover.matches) bindHover();
  canHover.addEventListener('change', (e) => {
    if (e.matches) bindHover();
    else unbindHover();
  });

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(play, 150);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.querySelectorAll('.marquee-container--animate').forEach(initMarquee);
});
